import React from "react";
import Fade from "react-reveal/Fade";

const SAVOUREZ_IMAGE_SRC = "/images/Rectangle 3464496.png";
const RESERVATION_URL = "https://r.ajamaat.com";

/**
 * Section promotionnelle "Savourez, sans bouger de chez vous !"
 * Affichée sous la section "Nos Produits" sur la homepage.
 * Le bouton redirige vers Ajamaat Mobilité (réservation restaurants).
 */
const SavourezSection: React.FC = () => {
  return (
    <section className="savourez-section my-5" aria-label="Savourez sans bouger de chez vous">
      <Fade bottom>
        <div className="savourez-section__inner">
          <div className="savourez-section__image-wrap">
            <img
              src={SAVOUREZ_IMAGE_SRC}
              alt="Plats cuisinés - Savourez sans bouger de chez vous"
              className="savourez-section__image"
              loading="lazy"
            />
          </div>
          <div className="savourez-section__content">
            <div className="savourez-section__block">
              <h2 className="savourez-section__title">
                Savourez, sans
                <br />
                bouger de chez vous !
              </h2>
              <p className="savourez-section__subtitle">
                Les meilleurs restaurants
                <br />
                près de chez vous
              </p>
              <div className="savourez-section__cta-wrap">
                <a
                  href={RESERVATION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="savourez-section__btn"
                >
                  Réserver dans un restaurant
                </a>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </section>
  );
};

export default SavourezSection;
